import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";

function DropZone({ fileSelected, setFileSelected }) {
  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles = acceptedFiles[0];
    setFileSelected(acceptedFiles);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/pdf": [".pdf"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
    },
  });

  return (
    <Stack flexDirection="row" gap={4} justifyContent="space-between" mt={4}>
      <Stack
        {...getRootProps()}
        sx={{
          backgroundColor: "RGB(243, 244, 246)",
          cursor: "pointer",
          borderRadius: 2,
          py: 2,
          px: 3,
          width: "40%",
          minHeight: 120,
          color: "RGB(108, 117, 128)",
          boxShadow: "inset -2px -2px 3px #4f4f4f47",
        }}
      >
        <input {...getInputProps()} multiple={false} />

        {fileSelected ? (
          <Box display="flex" flexDirection="column" gap="1" textAlign="center">
            <FileUploadOutlinedIcon
              sx={{ marginInline: "auto", mb: 2 }}
              fontSize="large"
            />
            <Typography>Archivo: {fileSelected.name}</Typography>
          </Box>
        ) : isDragActive ? (
          <Box display="flex" flexDirection="column" gap="1" textAlign="center">
            <FileUploadOutlinedIcon
              sx={{ marginInline: "auto", mb: 2 }}
              fontSize="large"
            />
            <Typography>Suelta el archivo ...</Typography>
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap="1" textAlign="center">
            <FileUploadOutlinedIcon
              sx={{ marginInline: "auto", mb: 2 }}
              fontSize="large"
            />
            <Typography sx={{ mb: 1 }}>
              Arrastra y suelta los archivos aquí
            </Typography>
            <Typography>O haz click para seleccionar</Typography>
          </Box>
        )}
      </Stack>
      <Stack sx={{ width: "60%" }}>
        <Typography component="h4" variant="h5" mb={2}>
          Sube tus archivos
        </Typography>
        <Typography fontWeight="normal">
          Sube tus archivos o documentos ya firmados para entrar en revisión y
          posteriormente se valide tu inversión.
        </Typography>
        <br />
        <Button
          size="small"
          sx={{
            px: "0.5rem",
            width: "fit-content",
            color: "white",
            backgroundColor: "primary.main",
            borderRadius: 2,
            "&:hover": {
              backgroundColor: "primary.300",
            },
          }}
          onClick={() => {
            const link = document.createElement("a");
            link.href = "/modelo_documento.pdf";
            link.download = "modelo_documento.pdf";
            link.click();
          }}
        >
          Descargar modelo de documento
        </Button>
      </Stack>
    </Stack>
  );
}

export default DropZone;

